import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0049c9b4&scoped=true"
import script from "./Main.js?vue&type=script&lang=js&external"
export * from "./Main.js?vue&type=script&lang=js&external"
import style0 from "./Main.vue?vue&type=style&index=0&id=0049c9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049c9b4",
  null
  
)

export default component.exports